import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box, useTheme } from '@mui/material';
export var InfoBox = function (_a) {
    var value = _a.value, label = _a.label;
    var theme = useTheme();
    return (_jsx(Box, { display: 'flex', flexDirection: 'column', borderRadius: '12px', gap: 1, padding: 2, bgcolor: theme.palette.common.white, boxShadow: theme.customShadows.z24, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 0.5, children: [_jsx(Typography, { variant: 'subtitle2', color: 'text.primary', children: value }), _jsx(Typography, { variant: 'body2', color: 'text.tertiary', children: label })] }) }));
};
